import Main from './Main'
import Accreditation from './Accreditation'
import EgeDetails from './Details/EgeDetails'
import EiocDetails from './Details/EiocDetails'
import TeachersDetails from './Details/TeachersDetails'
import StaffDetails from './Details/StaffDetails'
import StudentsDetails from './Details/StudentsDetails'
import VsokoDetails from './Details/VsokoDetails'
import DetailsLayout from './DetailsLayout'
import DetailsSPOLayout from './DetailsSPOLayout'
import Layout from './Layout'
import CIUP from './CIUP'



export default { Layout, Main, Accreditation, DetailsLayout, EgeDetails, EiocDetails, TeachersDetails, StaffDetails, StudentsDetails, VsokoDetails, DetailsSPOLayout, CIUP }